import commonConfig from '../../libs/configs/commonConfig';
import useAppConfig from './useAppConfig';

const useTermsAndConditionsUrl = () => {
  const { config } = useAppConfig().states;

  const termsAndConditionsUrl =
   config.termsAndConditions 
    ?? commonConfig.termsAndConditionsFallbackUrl;
  return {
    states: { termsAndConditionsUrl, termsAndConditionsExtraSeatUrl: config.termsAndConditionsExtraSeat },
    selectors:{ 
      // dynamic terms and conditions is only enabled when partner has both regular terms, and extra seat terms configured
      hasDynamicTermsAndConditions: Boolean(termsAndConditionsUrl) && Boolean(config.termsAndConditionsExtraSeat)
    }
  };
};

export default useTermsAndConditionsUrl;
